import numeral from 'numeral'
import 'numeral/locales/nl-be'
import 'numeral/locales/it'
import 'numeral/locales/pl'
import { Reducer } from 'redux'
import { AppAction } from '../types'
import { DataState } from '../types/dataTypes'

numeral.register('locale', 'de', {
  delimiters: {
    thousands: '.',
    decimal: ','
  },
  abbreviations: {
    thousand: 'k',
    million: 'm',
    billion: 'b',
    trillion: 't'
  },
  ordinal: function () {
    return '.'
  },
  currency: {
    symbol: '€'
  }
})

const getLangCode = (triluxLangCode: string): string => {
  switch (triluxLangCode) {
    case 'de':
      return 'de'
    case 'bx':
      return 'nl-be'
    case 'it':
      return 'it'
    case 'pl':
      return 'pl'
    default:
      return 'en'
  }
}

const initialState: DataState = {
  loading: true,
  applications: [],
  properties: [],
  menu: [],
  constraints: [],
  modules: [],
  portfolio: [],
  translations: {},
  assets: {},
  urls: {},
  language: '',
  system: {
    maxHeight: 0,
    width: 0
  }
}

const dataReducer: Reducer<DataState, AppAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'Data/SetUrls':
      return {
        ...state,
        urls: action.urls
      }
    case 'Data/Received':
      numeral.locale(getLangCode(action.data.language))
      return {
        loading: false,
        ...action.data,
        urls: state.urls
      }
    default:
      return state
  }
}

export default dataReducer
